import { List } from 'immutable'
const namespace = 'messages'

export const getMessagesIds = orderId => state => {
  return state[namespace].getIn(['conversation_messages', orderId, 'messages'], List())
}

export const getMessageById = msgId => state => {
  return state[namespace].getIn(['message_records', msgId])
}

export const sessionMessageInfo = orderId => state => {
  return state[namespace].getIn(['conversation_messages', orderId])
}
